import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-swap-gas-trend-viewer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './swap-gas-trend-viewer.component.html'
})
export class SwapGasTrendViewerComponent {
  @Input() gasTrendData: Record<'1h' | '3h' | '6h' | '24h', number> = {
    '1h': 0,
    '3h': 0,
    '6h': 0,
    '24h': 0
  };
  @Input() isLoading: boolean = false;
  @Input() hasData: boolean = true;
  @Output() applyPercentage = new EventEmitter<number>();

  periods: ('1h' | '3h' | '6h' | '24h')[] = ['1h', '3h', '6h', '24h'];

  handleClick(value: number): void {
    this.applyPercentage.emit(value);
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = Number(input.value);
    this.applyPercentage.emit(value);
  }

   isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }
}
